import { useEffect, useState } from "react";
import api from "@/lib/api";
import ActivityCard from "@/components/app/ActivityCard";
import { Calendar as CalIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function CalendarPage() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/calendar").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const upcoming = items.filter((a) => a.status !== "completed");
  const past = items.filter((a) => a.status === "completed");

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6 pb-32">
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mb-1">{t("calendar.title")}</h1>
      <p className="text-[#4A4A4A] mb-6">{t("calendar.subtitle")}</p>

      <h2 className="font-display font-black text-xl mb-3 flex items-center gap-2"><CalIcon className="w-5 h-5"/> {t("calendar.upcoming")} ({upcoming.length})</h2>
      {upcoming.length === 0 ? (
        <p className="card-nb p-6 bg-[#FFF0D4] mb-8" data-testid="calendar-empty">{t("calendar.empty")}</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
          {upcoming.map((a, i) => <ActivityCard key={a.id} activity={a} idx={i}/>)}
        </div>
      )}

      <h2 className="font-display font-black text-xl mb-3">{t("calendar.past")} ({past.length})</h2>
      {past.length === 0 ? (
        <p className="text-[#4A4A4A]">{t("calendar.nothingYet")}</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {past.map((a, i) => <ActivityCard key={a.id} activity={a} idx={i}/>)}
        </div>
      )}
    </div>
  );
}
